/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter } from './TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter';
import {
    TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSON,
    TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSONTyped,
    TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterToJSON,
} from './TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter';

/**
 * 
 * @export
 * @interface TrackItMeasurementParameterFilterWithUserValueDto
 */
export interface TrackItMeasurementParameterFilterWithUserValueDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterFilterWithUserValueDto
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementParameterFilterWithUserValueDto
     */
    isEnabled?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrackItMeasurementParameterFilterWithUserValueDto
     */
    isCustom?: boolean;
    /**
     * 
     * @type {TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter}
     * @memberof TrackItMeasurementParameterFilterWithUserValueDto
     */
    measurementParameter?: TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameter | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterFilterWithUserValueDto
     */
    $type?: TrackItMeasurementParameterFilterWithUserValueDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterFilterWithUserValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterFilterWithUserValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterFilterWithUserValueDtoTypeEnum = typeof TrackItMeasurementParameterFilterWithUserValueDtoTypeEnum[keyof typeof TrackItMeasurementParameterFilterWithUserValueDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterFilterWithUserValueDto interface.
 */
export function instanceOfTrackItMeasurementParameterFilterWithUserValueDto(value?: unknown): value is TrackItMeasurementParameterFilterWithUserValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterFilterWithUserValueDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterFilterWithUserValueDtoFromJSON(json: any): TrackItMeasurementParameterFilterWithUserValueDto {
    return TrackItMeasurementParameterFilterWithUserValueDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterFilterWithUserValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterFilterWithUserValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'isCustom': json['isCustom'] == null ? undefined : json['isCustom'],
        'measurementParameter': json['measurementParameter'] == null ? undefined : TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterFromJSON(json['measurementParameter']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterFilterWithUserValueDtoToJSON(value?: TrackItMeasurementParameterFilterWithUserValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'isEnabled': value['isEnabled'],
        'isCustom': value['isCustom'],
        'measurementParameter': TrackItMeasurementParameterFilterWithMatchingValueDtoMeasurementParameterToJSON(value['measurementParameter']),
        '$type': value['$type'],
    });
}

